/**
 * Widget Error Fallback
 *
 * Widget-sized error card shown when a dashboard widget fails to render
 * or its data fetch errors out. Provides a retry button that clears the
 * error state and re-triggers the data fetch.
 */

import { AlertTriangle, RefreshCw } from "lucide-react";

interface WidgetErrorFallbackProps {
  /** Called when user clicks "Retry" — typically a refetch or state reset */
  onRetry?: () => void;
  /** Optional custom message (default: "Failed to load") */
  message?: string;
}

export function WidgetErrorFallback({
  onRetry,
  message = "Failed to load",
}: WidgetErrorFallbackProps) {
  return (
    <div className="widget">
      <div className="widget-body py-6 flex flex-col items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-accent-red/60" />
        <p className="text-xs text-text-muted">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 text-xs text-text-muted hover:text-text-primary transition-colors mt-1"
          >
            <RefreshCw className="w-3 h-3" />
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
